export default "__VITE_ASSET__CoB3A0gF__"